<template>
    <div class="container-fluid">
        <div><h3>Filiais</h3></div>
        <form class="row search">
            <div class="form-group col-md-12">
                <input v-on:keyup="filterSubsidiaries" class="form-control" id="search" v-model="search" ref="search" placeholder="Busca"/>
            </div>
        </form>
        <div class="tab-content" id="pills-tabContent">
            <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="active-tab">
                <table class="table table-striped">
                    <thead>
                    <tr>
                      <th>Razão Social</th>
                      <th>Dias para bloqueio</th>
                      <th>Tolerância(%)</th>
                      <th>Caixa</th>
                      <th>Ticket</th>
                      <th>Conflito</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="subsidiary in subsidiaries" :key="subsidiary.id">
                        <td><input class="form-control hide-input" v-model="subsidiary.name" v-on:blur="edit(subsidiary)"></td>
                        <td><input class="form-control hide-input" v-model="subsidiary.deadline" v-on:blur="edit(subsidiary)"></td>
                        <td><input class="form-control hide-input" v-model="subsidiary.tolerance" v-on:blur="edit(subsidiary)"></td>
                        <td><div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="subsidiary.regime" v-on:change="edit(subsidiary)">
                            <label class="form-check-label" for="apportionment">
                                Regime de caixa
                            </label>
                        </div></td>
                      <td><div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="subsidiary.ticket" v-on:change="edit(subsidiary)">
                        <label class="form-check-label">
                          Bloqueia s/ ticket
                        </label>
                      </div></td>
                      <td><div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="subsidiary.allow_time_conflict" v-on:change="edit(subsidiary)">
                        <label class="form-check-label">
                          Permite conflito
                        </label>
                      </div></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'Subsidiaries',
    data () {
      return {
        subsidiaries: {},
        name: '',
        deadline: 1,
        regime: 1,
        search: '',
        ticket: false,
        deletedSubsidiaries: {},
        errors: {}
      }
    },
    mounted (){
        this.index()
    },
    methods: {
      create () {
        axios.post('/api/subsidiaries', {
          name: this.name,
          deadline: this.deadline,
          tolerance: this.tolerance,
          regime: this.regime,
          ticket: this.ticket
        }).then(() => {
          this.name = ''
          this.deadline = 1
          this.regime = 0
          this.ticket = false
          this.$refs.name.focus()
          this.filterSubsidiaries()
          this.errors = {}
        }).catch((error) => {
          this.errors = error.response.data.errors;
        })
      },
      index () {
        axios
          .get('/api/subsidiaries?search=' + this.search)
          .then((response) => {
            this.subsidiaries = response.data.data
        })
      },
      edit (subsidiary) {
        axios.put('/api/subsidiaries/' + subsidiary.id, {
          name: subsidiary.name,
          deadline: subsidiary.deadline,
          tolerance: subsidiary.tolerance,
          regime: subsidiary.regime,
          ticket: subsidiary.ticket,
          allow_time_conflict: subsidiary.allow_time_conflict
        }).then(() => {
          this.index()
        }).catch((error) => {
          this.errors = error.response.data.errors
          let message = ''
          for (let i in this.errors) {
            message = this.errors[i] + '<br />' + message
          }
          this.$swal({
            title: 'Ops...',
            text: message,
            icon: 'error',
            html: message
          }).then(() => {
            this.index()
          })
        })
      },
      filterSubsidiaries () {
        this.index()
        this.deleted()
      }
    }
  }
</script>

<style scoped lang="sass">
    .btn-save
        margin-left: 20px

    #apportionment
        margin-top: 9px

    .search
        margin-top: 15px
        border-top: 1px solid #3c3c3c
        padding: 15px 0

    .subsidiary-since
        margin-right: 10px
</style>
